import { IconAccountGear, IconBroom, IconStar } from '../assets/DesignSystem/SVGComponents';
import { getConfigClassDisplayName } from '../utils/configurations';
import {
  IadditionalServiceDataForToolLogistics,
  CONFIG_STATUS_NAME,
  CONFIG_STATUS_NAME_COLOR,
  LS_ADDITIONAL_SERVICE_TYPE
} from '../types/product.configuration.types';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import { BordOneToneIcon } from 'components/NudosComponents';
import { CURRENCIES } from 'types/bussines';
import { CONFIG_CLASS_ID } from 'types/product.configuration.types';

export const getAdditionalServiceDisplayElements = (additionalServiceData: IadditionalServiceDataForToolLogistics) => {
  const { status: statusData, comments, configClassId } = additionalServiceData;
  const { statusName } = statusData || {};
  const callToActionText = statusName === CONFIG_STATUS_NAME.NOT_COMPLETED ? 'Ver motivos' : 'Ver';
  const statusWithDefault = statusName || CONFIG_STATUS_NAME.TO_COMPLETE;
  switch (configClassId) {
    case CONFIG_CLASS_ID.WIPING:
      return {
        text: LS_ADDITIONAL_SERVICE_TYPE.WIPING,
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconBroom className="iconBroom additionalServiceIcon" />
      };
    case CONFIG_CLASS_ID.BASIC_CONFIGURATION:
      return {
        text: 'Conf. básica',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconAccountGear className="iconAccountGear additionalServiceIcon" />
      };
    case CONFIG_CLASS_ID.CONFIG_AVANZADA:
      return {
        text: 'Conf. avanzada',
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <IconStar className="iconStar additionalServiceIcon" />
      };
    default:
      return {
        text: getConfigClassDisplayName(configClassId),
        status: statusWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[CONFIG_STATUS_NAME.TO_COMPLETE],
        callToActionText,
        icon: <IconStar className="iconStar additionalServiceIcon" />
      };
  }
};
export const getAdditionalServiceDisplayElementsBord = (
  additionalServiceData: IadditionalServiceDataForToolLogistics
) => {
  const { status: statusData, comments, configClassId } = additionalServiceData;
  const { statusName, statusNameStringId } = statusData || {};

  const itIsAnAdditionalConfiguration = !!configClassId;
  const callToActionText = statusName === CONFIG_STATUS_NAME.NOT_COMPLETED ? 'Ver motivos' : 'Ver';
  const statusWithDefault = statusName || CONFIG_STATUS_NAME.TO_COMPLETE;
  const statusNameStrings = {
    'subs_lass_completed_9f11f658-de40-4608-a55f-94f907a22b01': 'Completado',
    'subs_lass_toComplete_72d5baf0-b491-47bb-a547-db654f6159ac': 'Por completar',
    'subs_lass_notCompleted_d55847a0-1827-4960-922f-29a0ab888362': 'No completado',
    'subs_lasncr_MDM_cfca327e-9d21-4e66-b141-a05656d28baf': 'MDM',
    'subs_lasncr_appleLocked_eff0f6e7-1696-450e-b326-2ea2af61b3b3': 'Bloqueado por Apple ID',
    'subs_lasncr_userLocked_4a03972e-ddf0-45d8-917b-8d6c44b42387': 'Bloqueado por el usuario',
    'subs_lasncr_notFunctional_a68b985b-859e-4678-b443-ce21eb43136a': 'Equipo no funcional'
  };
  const statusTranslateWithDefault =
    statusNameStrings[statusNameStringId as keyof typeof statusNameStrings] || statusName || 'Completado';
  const assignSpecificIcon = () => {
    if (!configClassId) return;
    const variantGroups: [TbordOneToneIcon, number[]][] = [
      ['apple', [2, 4]],
      ['cpu', [3]],
      ['hash', [5]],
      ['atSign', [6]],
      ['sliders', [7]],
      ['star', [8, 12]],
      ['wiping', [9]],
      ['shield', [10, 11]],
      ['laptopSettings', [1]]
    ];
    const variant = variantGroups.find(([, ids]) => ids.includes(configClassId))?.[0] ?? 'star';
    return <BordOneToneIcon stroke="#626C82" variant={variant} customWidth="14px" />;
  };

  switch (configClassId) {
    case CONFIG_CLASS_ID.WIPING:
      return {
        text: LS_ADDITIONAL_SERVICE_TYPE.WIPING,
        status: statusTranslateWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="wiping" customWidth="14px" stroke="#626C82" />
      };
    case CONFIG_CLASS_ID.BASIC_CONFIGURATION:
      return {
        text: 'Conf. básica',
        status: statusTranslateWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="settings" customWidth="14px" stroke="#626C82" />
      };
    case CONFIG_CLASS_ID.CONFIG_AVANZADA:
      return {
        text: 'Conf. avanzada',
        status: statusTranslateWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[statusWithDefault],
        callToActionText,
        icon: <BordOneToneIcon variant="star" customWidth="14px" stroke="#626C82" />
      };
    default:
      return {
        text: additionalServiceData?.name || 'Sin información',
        status: statusTranslateWithDefault,
        comments,
        color: CONFIG_STATUS_NAME_COLOR[CONFIG_STATUS_NAME.TO_COMPLETE],
        callToActionText,
        icon: itIsAnAdditionalConfiguration ? (
          assignSpecificIcon()
        ) : (
          <BordOneToneIcon variant="star" customWidth="14px" stroke="#626C82" />
        )
      };
  }
};
export const paymentDateBlockedMessage = ({ customClassName }: { customClassName?: string }) => (
  <div className={customClassName}>
    No puedes configurar acuerdo <br /> de pago para pagos con <br /> tarjeta de crédito
  </div>
);

export const VOLATILE_CURRENCIES = [CURRENCIES.ARS, CURRENCIES.BRL];
